"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tokens = require("@ellucian/react-design-system/core/styles/tokens");
// Ellucian's CTA Colors

var ctaColor = {
  blue: {
    base: _tokens.colorCtaBlueBase,
    hover: _tokens.colorCtaBlueHover,
    active: _tokens.colorCtaBlueActive,
    tint: _tokens.colorCtaBlueTint
  },
  green: {
    base: _tokens.colorCtaGreenBase,
    hover: _tokens.colorCtaGreenHover,
    active: _tokens.colorCtaGreenActive,
    tint: _tokens.colorCtaGreenTint
  },
  iris: {
    base: _tokens.colorCtaIrisBase,
    hover: _tokens.colorCtaIrisHover,
    active: _tokens.colorCtaIrisActive,
    tint: _tokens.colorCtaIrisTint
  },
  plum: {
    base: _tokens.colorCtaPlumBase,
    hover: _tokens.colorCtaPlumHover,
    active: _tokens.colorCtaPlumActive,
    tint: _tokens.colorCtaPlumTint
  },
  taupe: {
    base: _tokens.colorCtaTaupeBase,
    hover: _tokens.colorCtaTaupeHover,
    active: _tokens.colorCtaTaupeActive,
    tint: _tokens.colorCtaTaupeTint
  }
};
var _default = ctaColor;
exports.default = _default;